export interface MaxHoursExceededDetail {
  workerNumber: string;
  workerDescription: string;
  previousHours: number;
  newHours: number;
}

export class MaxHoursExceededError extends Error {
  readonly maxRegistrationHours: number;
  readonly overLimitWorkers: MaxHoursExceededDetail[];

  constructor(maxRegistrationHours: number, overLimitWorkers: MaxHoursExceededDetail[]) {
    super('MaxRegistrationHours exceeded');
    this.name = 'MaxHoursExceededError';
    this.maxRegistrationHours = maxRegistrationHours;
    this.overLimitWorkers = overLimitWorkers;
    Object.setPrototypeOf(this, MaxHoursExceededError.prototype);
  }
}
